export const MANAGER_MAPPER = {
  new_orders: {
    waiting_client: () => import('./new-orders/NewOrdersToWaitingClientManager'),
    waiting_budget: () => import('./new-orders/NewOrdersToWaitingBudgetManager'),
    pending_owner: () => import('./new-orders/NewOrdersToPendingOwnerManager'),
    pending_third_party: () => import('./new-orders/NewOrdersToPendingThirdPartyManager'),
  },
  triage: {
    allocate_provider: () => import('./triage/TriageToAllocateProviderManager'),
    waiting_client: () => import('./triage/TriageToWaitingClientManager'),
  },
  allocate_provider: {
    waiting_client: () => import('./allocate-provider/AllocateProviderToWaitingClientManager'),
  },
  waiting_client: {
    waiting_budget: () => import('./waiting-client/WaitingClientToWaitingBudgetManager'),
    pending_owner: () => import('./waiting-client/WaitingClientToPendingOwnerManager'),
    pending_third_party: () => import('./waiting-client/WaitingClientToPendingThirdPartyManager'),
  },
  waiting_budget: {
    negotiate_budget: () => import('./waiting-budget/WaitingBudgetToNegotiateBudgetManager'),
    review_budget: () => import('./waiting-budget/WaitingBudgetToReviewBudgetManager'),
    pending_owner: () => import('./waiting-budget/WaitingBudgetToPendingOwnerManager'),
    pending_third_party: () => import('./waiting-budget/WaitingBudgetToPendingThirdPartyManager'),
  },
  review_budget: {
    send_budget_to_payer: () => import('./review-budget/ReviewBudgetToSendBudgetToPayerManager'),
  },
  negotiate_budget: {
    allocate_provider_pre_approved_budget: () =>
      import('./negotiate-budget/NegotiateBudgetToAllocateProviderPreApprovedBudgetManager'),
    waiting_execution: () => import('./negotiate-budget/NegotiateBudgetToWaitingExecutionManager'),
    pending_owner: () => import('./negotiate-budget/NegotiateBudgetToPendingOwnerManager'),
    pending_third_party: () =>
      import('./negotiate-budget/NegotiateBudgetToPendingThirdPartyManager'),
  },
  allocate_provider_pre_approved_budget: {
    waiting_execution: () =>
      import(
        './allocate-provider-pre-approved-budget/AllocateProviderPreApprovedBudgetToWaitingExecutionManager'
      ),
    pending_owner: () =>
      import(
        './allocate-provider-pre-approved-budget/AllocateProviderPreApprovedBudgetToPendingOwnerManager'
      ),
    pending_third_party: () =>
      import(
        './allocate-provider-pre-approved-budget/AllocateProviderPreApprovedBudgetToPendingThirdPartyManager'
      ),
  },
  waiting_execution: {
    waiting_finalization: () =>
      import('./waiting-execution/WaitingExecutionToWaitingFinalizationManager'),
    pending_owner: () => import('./waiting-execution/WaitingExecutionToPendingOwnerManager'),
    pending_third_party: () =>
      import('./waiting-execution/WaitingExecutionToPendingThirdPartyManager'),
  },
  waiting_finalization: {
    finished: () => import('./waiting-finalization/WaitingFinalizationToFinishedManager'),
    reproved_service: () =>
      import('./waiting-finalization/WaitingFinalizationToReprovedServiceManager'),
  },
  reproved_service: {
    waiting_finalization: () =>
      import('./reproved-service/ReprovedServiceToWaitingFinalizationManager'),
    finished: () => import('./reproved-service/ReprovedServiceToFinishedManager'),
  },
}
